// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__25Yyk","rootSmall":"AddTileButton_rootSmall__1lMKV"};